<template>

    <accordion-input :accordion="accordion" :spacing="spacing" :open="open">
        <template #label>

            <div class="font-medium">Ankerpunt</div>

        </template>
        <template #content>

            <small class="block mb-3 text-gray-500 text-muted">
                Vul hier een anchor in. Dit betreft het # deel achter een url. Hiermee kan je linken naar dit blok.
            </small>

            <input type="text"
                   class="focus:border-indigo-600 focus:outline-none focus:shadow-outline-blue form-control form-input sm:leading-5 sm:text-sm border border-gray-300 border-solid duration-150 ease-in-out mt-1 px-3 py-2 rounded-md transition w-full"
                   @input="$set(options, 'anchor', $event.target.value)"
                   placeholder="categorie"
                   :value="options.anchor"
            />

        </template>
    </accordion-input>

</template>

<script>

import AccordionInput from "@galaxy/modules/Canvas/resources/js/editor/website/editors/inputs/helpers/Input";

export default {

    components: {
        AccordionInput
    },

    props: {
        options: Object,

        spacing: {
            horizontal: {
                type: Boolean,
                default: true
            },
            vertical: {
                type: Boolean,
                default: true
            }
        },

        accordion: {
            type: Boolean,
            default: true
        },

        open: {
            type: Boolean,
            default: null
        },
    },

    data()
    {
        return {
            isOpen: this.open || false,
        };
    }

}

</script>
